module.exports = {
      id: "logo-casar-usage",
      viewBox: "0 0 451 116",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#logo-casar",
      toString: function () {
        return this.url;
      }
    }